/*import { useTranslation } from "react-i18next";*/
import { useEffect, useState } from "react";
import { classNames } from "src/helpers/mixins";

type DialogConfirmParams = {
  show: boolean
  closeDialog(): void 
  children:  JSX.Element | React.ReactNode
  disabledFooter?: boolean
  size?: string
  disabledClosable?:boolean
}

const DialogConfirm = ({show, closeDialog, size, children,disabledFooter,disabledClosable}:DialogConfirmParams) => {
  //const { t } = useTranslation();
  const [animateClose, setAnimateClose] = useState<boolean>(false)
  const willAnimateClose = () => {
    setAnimateClose(true)
    window.setTimeout(() => {
      closeDialog()
      setAnimateClose(false)
    },500)
  }

  useEffect(() => {
    //setAnimateClose(false)
  }, [])
  
  return (
    <>
      {show &&
        <div
          className={classNames("relative z-[14000]", animateClose ? 'fadeout' :'fadein')}
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-stone-900 bg-opacity-40 transition-opacity"></div>

          <div className="fixed inset-0 z-[14000] w-screen overflow-y-auto">
            <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
              <div className={classNames(`relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-11/12`, (size ? `xl:${size}` : `xl:w-1/2`))}>
                <div className="bg-white  relative rounded-lg">
                  {!disabledClosable && 
                    <div
                      aria-label="cerrar"
                      role="button"
                      onClick={() => willAnimateClose()}
                      className="bg-red-500 text-white transition-all flex items-center font-bold justify-center text-xl cursor-pointer w-8 h-8 z-10 rounded-full absolute -right-4 -top-4 "
                    >
                      X
                    </div>
                  }
    
                  <div>
                  {children}
                  </div>
                  {!disabledFooter &&
                    <div className="flex flex-row gap-3 items-center px-4 md:px-10 pb-4 justify-center border-t border-gray-300">
                      <button onClick={() => willAnimateClose()} className="bg-green-logo rounded-lg font-semibold text-base px-8 mt-4 py-1 text-white text-center">
                        OK
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};
export default DialogConfirm;
